module.exports = __webpack_public_path__ + "fonts/CiscoSansTTBold.woff2";